
import { defineComponent } from 'vue'
import { colors } from '@/data/colors'

export default defineComponent({
  props: {
    langs: {
      type: Object,
      required: true,
      validator: (value: any) => {
        return typeof value === 'object' && value !== null
      },
    },
    repoFullName: {
      type: String,
      required: true,
    },
  },
  data() {
    return { colors }
  },
  computed: {
    totalBytes(): number {
      if (!this.langs || !this.langs[this.repoFullName]) return 0

      return Object.values(this.langs[this.repoFullName]).reduce(
        (a: number, b: unknown) => a + Number(b),
        0
      )
    },
    hasLangs(): boolean {
      return !!(this.langs && this.langs[this.repoFullName])
    },
  },
  methods: {
    calculatePercentage(val: number): number {
      if (this.totalBytes === 0) return 0
      return Math.round((10000 * val) / this.totalBytes) / 100
    },
  },
})
